export default __webpack_public_path__ + "static/media/rd5.b34a068e.png";